import { FormattedMessage } from 'react-intl';

import './style.scss';

const TIERS = [
  { min: 0, key: 'silver', icon: '🥉' },
  { min: 3, key: 'gold', icon: '🥈' },
  { min: 10, key: 'platinum', icon: '🥇' },
] as const;

interface IProps {
  rewardsEarnedCount: number;
}

function getTier(count: number): (typeof TIERS)[number] {
  for (let i = TIERS.length - 1; i >= 0; i--) {
    if (count >= TIERS[i].min) return TIERS[i];
  }
  return TIERS[0];
}

export function RewardsTierBadge(props: IProps) {
  const { rewardsEarnedCount } = props;
  const tier = getTier(rewardsEarnedCount);

  return (
    <div className="rewards-tier-badge">
      <span className="rewards-tier-badge__icon">{tier.icon}</span>
      <span className="rewards-tier-badge__text">
        <FormattedMessage
          id={`rewards.tier.${tier.key}`}
          values={{ count: rewardsEarnedCount }}
        />
      </span>
    </div>
  );
}
